// extracted by mini-css-extract-plugin
module.exports =  {"hidden":"_93444fe79c--hidden--kU8J2"};